import React from 'react';
import { Card, Spin } from 'antd';

const UserProfile = ({ keycloakProfile }) => {
  if (!keycloakProfile) {
    return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: 80 }} />;
  }

  return (
    <Card title="User Profile">
      <p><strong>First Name:</strong> {keycloakProfile.firstName}</p>
      <p><strong>Last Name:</strong> {keycloakProfile.lastName}</p>
      <p><strong>Email:</strong> {keycloakProfile.email}</p>
      <p><strong>Username:</strong> {keycloakProfile.username}</p>
    </Card>
  );
};

export default UserProfile;
